<template>
    <v-card class="page-header mb-4" elevation="1">
        <div class="page-header__top">
            <div class="page-header__title">
                <span v-if="icon" class="page-header__icon"><v-icon small color="white">{{ icon }}</v-icon></span>
                <span class="page-header__text">{{ title }}</span>
                <slot name="title-append" />
            </div>
            <div v-if="$slots.actions" class="page-header__actions">
                <slot name="actions" />
            </div>
        </div>
        <div v-if="$slots.default" class="page-header__body">
            <slot />
        </div>
    </v-card>
</template>

<script>
    export default {
        name: 'PageHeader',
        props: {
            title: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                default: null
            }
        }
    }
</script>

<style scoped>
    /* the section bands of the website: title in Squada One, the icon on the teal-to-blue gradient */
    .page-header {
        border-top: 3px solid #232323 !important;
    }

    .page-header__icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 30px;
        border-radius: 6px;
        background: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
    }

    .page-header__text {
        font-family: 'Squada One', Arial, sans-serif;
        font-size: 1.6rem;
        line-height: 1.1;
        letter-spacing: 0.03em;
        text-transform: uppercase;
        color: #232323;
    }

    .page-header__top {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 8px 16px;
        padding: 12px 16px;
    }

    .page-header__title {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
    }

    .page-header__actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
    }

    .page-header__body {
        border-top: 1px solid rgba(0, 0, 0, 0.08);
    }
</style>
